const getFormMessages = ({ data }) => ({
  firstName: {
    invalid: data?.invalidNameError || 'Invalid name',
    required: data?.firstNameError || 'First name is required',
  },
  lastName: {
    invalid: data?.invalidNameError || 'Invalid last name',
    required: data?.lastNameError || 'Last name is required',
  },
  email: {
    invalid: data?.emailError || 'Please enter a valid email address',
    required: data?.emailError || 'Email is required',
  },
  phoneNumber: {
    invalid: data?.phoneNumberError || 'Please enter a valid phone number',
    required: data?.phoneNumberError || 'Please enter a valid phone number',
  },
  city: {
    invalid: data?.cityLabelError || 'Please choose a city',
    required: data?.cityLabelError || 'Please choose a city',
  },

  ageConsent: {
    required: data?.ageConsentError || 'Please confirm that you are 18 age or above',
  },
  additionalInfo: {
    required: data?.additionalInfoError || 'Additional information is required',
  },
});

export default getFormMessages;
